<template>
    <!-- Aba de Histórico -->
    <div class="tab-pane fade show active" id="sphericalShellsPressConcaveCalculator">
        
        <!-- BOTÃO DESENHO DE APOIO -->
        <h5 class="text mt-5 text-primary">
            <b>Desenho de apoio</b>
        </h5>

        <!-- VER DESENHO -->
        <div class="col-2">
            <button
            type="button"
            class="btn btn-secundario"
            @click="mostrarDesenho()"
            >
            Mostrar desenho
            </button>
        </div>

        <!-- POPUP COM O DESENHO -->
        <DesenhoApoio
        v-model="showDrawing"
        :tipo="2"
        />
        
        <h5 class="text mt-5 text-primary"><b>Spherical Shell/Heads Under Pressure on Concave Side According to ASME VIII Div.1 (UG-27)
		</b></h5>

        <form ref="formCalculo" @submit.prevent="calculos">
            <div class="form-group row">
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>1. DESIGN DATA</b></h5>
                </div>
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>SYMBOLS USED IN THE FORMULAS AND DRAWING	</b></h5>
                </div>
            </div>

            <div class="table-responsive material-table">
                <table class="table mt-5">
                    <thead>
                        <tr>
                            <th scope="col">DESIGN DATA</th>
                            <th scope="col"></th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">
                                <span><b>Material Specification <br>(ASME II part D)</b></span>
                                <InterrogacaoHover text="Busca do material conforme ASME Section II Part D. A seleção define propriedades mecânicas como tensão admissível (Sh e Sc), limites de temperatura e parâmetros necessários para o dimensionamento do casco esférico." />
                            </th>
                            <td>
                                <!-- Container com posição relativa para conter a lista -->
                                <div class="position-relative">
                                    <!-- BUSCA -->
                                    <div class="position-relative">
                                        <input
                                            type="search"
                                            class="form-control ps-5 input"
                                            placeholder="Buscar material"
                                            v-model="materialSearch"
                                            @focus="abrirListaMaterial"
                                            @click="abrirListaMaterial"
                                            @input="handleInput"
                                            @blur="fecharListaMaterial"
                                            required
                                        />

                                        <!-- ÍCONE LUPA -->
                                        <span
                                            class="position-absolute start-0 top-50 translate-middle-y ps-3"
                                        >
                                            <img src="@/views/img/search-icon.svg" width="16" />
                                        </span>
                                    </div>

                                    <!-- LISTA DE RESULTADOS - Agora dentro do container position-relative -->
                                    <ul
                                        v-if="mostrarListaMaterial && materiaisFiltrados.length"
                                            class="material-options list-group position-absolute w-100 mt-1"
                                    >
                                        <li
                                                class="material-option list-group-item list-group-item-action"
                                            v-for="(material, index) in materiaisFiltrados"
                                            :key="material.materialSpecification + index"
                                            @mousedown.prevent="selecionarMaterial(material)"
                                        >
                                            <b>{{ [material.materialSpecification, material.classConditionTemper].filter(Boolean).join(" ") }}</b>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Nominal Composition</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.nominalComposition }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Product Form</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.productForm }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Alloy Designation/UNS No.</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.alloyDesignation }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Class/Condition/Temper</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.classConditionTemper }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">P-No.</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.pNo }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Group No.</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.groupNo }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Min. Tensile Strength</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.minTensileStrength }}
                                </h6>
                            </td>
                            <td> </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Min. Yield Strength</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.minYieldStrength }}
                                </h6>
                            </td>
                            <td> </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">VIII-1—Applic, and Max, Temp, Limit (°C)</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.viiiApplicAndMaxTemLimit }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Design Temperature</th>
                            <td>DT</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.designTemperature }}
                                </h6>
                            </td>
                            <td>°C</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Inside Diameter</b></span>
                                <InterrogacaoHover text="Diâmetro interno do casco esférico. Parâmetro fundamental para cálculo da espessura mínima sob pressão interna, conforme ASME VIII Div.1 UG-27." />
                            </th>
                            <td><b>Di</b></td>
                            <td>
                                <input type="number" step="any" class="form-control" v-model="sphericalShellsPressConcaveCalculator.insideDiameter" required/>
                            </td>
                            <td><b>mm</b></td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Liquid Column</b></span>
                                <InterrogacaoHover text="Altura da coluna líquida acima do ponto considerado. Utilizada para calcular a pressão hidrostática no interior do casco esférico." />
                            </th>
                            <td><b>H</b></td>
                            <td>
                                <input type="number" step="any" class="form-control" v-model="sphericalShellsPressConcaveCalculator.liquidColumn" 
                                :disabled="posicao === 'Cima' || designDataPosition === 'Horizontal'" required/>
                            </td>
                            <td><b>m</b></td>
                        </tr>
                        <tr>
                            <th scope="row">Fluid Density</th>
                            <td>-</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.density }}
                                </h6>
                            </td>
                            <td>kg/m³</td>
                        </tr>
                        <tr>
                            <th scope="row">Design Pressure on the Top of the Vessel</th>
                            <td>Pint</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.designPressureTop }} 
                                </h6>
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Design Pressure</th>
                            <td>P</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.designPressure }}
                                </h6>
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Admissible Stress @ Design Temperature</th>
                            <td>Sh</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.admissibleStressDesignTemp }}
                                </h6>
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Admissible Stress @ Room Temperature</th>
                            <td>Sc</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.admissibleStressRoomTemp }}
                                </h6>
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Inside Radius</th>
                            <td>Ri</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.insideRadius }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Inside Radius Corroded</th>
                            <td>Ric</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.insideRadiusCorroded }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Corrosion Allowance</th>
                            <td>CA</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.corrosionAllowance }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Nominal Thickness minus Corrosion Allowance</th>
                            <td>CA</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.nominalThicknessMinusCorrosionAloowance }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Welded Joint Efficiency</b></span>
                                <InterrogacaoHover text="Eficiência da junta soldada (E). Representa a qualidade da soldagem conforme o tipo de inspeção (radiografia total, parcial ou sem inspeção), influenciando diretamente na espessura requerida." />
                            </th>
                            <td><b>-</b></td>
                            <td>
                                <select class="form-select" v-model="sphericalShellsPressConcaveCalculator.weldedJointEfficiency" required>
                                    <option value="" selected>Selecione</option>
                                    <option value="1.00">1.00</option>
                                    <option value="0.90">0.90</option>
                                    <option value="0.85">0.85</option>
                                    <option value="0.80">0.80</option>
                                    <option value="0.70">0.70</option>
                                    <option value="0.65">0.65</option>
                                    <option value="0.60">0.60</option>
                                </select>
                            </td>
                            <td><b>--</b></td>
                        </tr>
                        <tr>
                            <th scope="row">
                                <span><b>Nominal Thickness</b></span>
                                <InterrogacaoHover text="Espessura nominal selecionada para o casco esférico. Deve ser igual ou superior à espessura mínima calculada, considerando corrosão, tolerâncias de fabricação e requisitos normativos." />
                            </th>
                            <td><b>-</b></td>
                            <td>
                                <select class="form-select" v-model="sphericalShellsPressConcaveCalculator.nominalThickness" required>
                                    <option value="" selected>Selecione</option>
                                    <option v-for="opcao in nominalThicknessOptions" :key="opcao" :value="opcao">
                                        {{ opcao }}
                                    </option>
                                </select>
                            </td>
                            <td><b>--</b></td>
                        </tr>

                        <!-- Scroll para ver resultados -->
                        <div class="mb-5" id="calculation-results"></div>
                        
                    </tbody>
                </table>
            </div>

            <tr></tr>
            <!-- Calculation results -->
            <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 gap-md-3">
                <h4 class="mb-0">
                    <b>Calculation Results:</b>
                </h4>

                <span
                    v-if="sphericalShellsPressConcaveCalculator.validNominalThickness"
                    class="badge bg-success fs-6 px-3 py-2"
                >
                    <b>✔ Nominal Thickness Valid</b>
                </span>

                <span
                    v-else
                    class="badge bg-danger fs-6 px-3 py-2"
                >
                    <b>✖ Nominal Thickness Not Valid</b>
                </span>
            </div>

            <div class="form-group calculator-drawing mt-3 row">
                <div class="calculator-drawing-title">Drawing</div>
                <div class="col d-flex justify-content-center">
                    <div class="calculator-drawing-frame">
                        <img src="../img/calculator-spherical-shells-press-concave/drawing-spherical-shells-press-concave.png" width="400px" alt="Escala de bristol" class="calculator-drawing-image">
                    </div>
                </div>
            </div>

            <!-- Design Validation -->
            <div class="form-group row">
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>2. DESIGN VALIDATION</b></h5>
                </div>
                <div class="col-6">
                    <h5 class="text mt-5 text-primary" v-if="sphericalShellsPressConcaveCalculator.validNominalThickness === true">
                        <b>VALID NOMINAL THICKNESS</b>
                    </h5>
                    <h5 class="text mt-5 text-danger" v-if="sphericalShellsPressConcaveCalculator.validNominalThickness === false">
                        <b>INVALID NOMINAL THICKNESS</b>
                    </h5>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-5">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 40%; text-align: left;">DESIGN DATA</th>
                            <th scope="col" style="width: 20%; text-align: center;"></th>
                            <th scope="col" style="width: 20%; text-align: center;">VALUE</th>
                            <th scope="col" style="width: 20%; text-align: center;">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row" style="text-align: left;">
                                Design Thickness
                                <div class="form-group mt-3 row">
                                    <label class="mt-1"><b>LONGITUDINAL JOINTS </b></label>
                                    <div class="col d-flex">
                                        <img src="../img/calculator-spherical-shells-press-concave/design-thickness.png" width="300px" alt="Formula for Thickness">
                                    </div>
                                    <span class="badge bg-light text-dark border mt-1">
                                        O resultado considera 10% para compensar o efeito de estricção
                                    </span>
                                </div>
                            </th>
                            <td style="text-align: center;">t</td>
                            <td style="text-align: center;">
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.designThickness }}
                                </h6>
                            </td>
                            
                            <td style="text-align: center;">mm</td>
                        </tr>
                        <tr>
                            <th scope="row" style="text-align: left;">
                                Working Maximum Allowable Pressure
                                <div class="form-group mt-3 row">
                                    <label class="mt-1"><b>LONGITUDINAL JOINTS </b></label>
                                    <div class="col d-flex">
                                        <img src="../img/calculator-spherical-shells-press-concave/working-maximum-allowable-pressure.png" width="300px" alt="Formula for MAWPc">
                                    </div>
                                </div>
                            </th>
                            <td style="text-align: center;">MAWPc</td>
                            <td style="text-align: center;">
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.workingMaximumAllowablePressure }}
                                </h6>
                            </td>
                            <td style="text-align: center;">MPa</td>
                        </tr>
                        <tr>
                            <th scope="row" style="text-align: left;">
                                Hydrostatic Test Pressure
                                <div class="form-group mt-3 row">
                                    <label class="mt-1"><b>HIDROSTATIC TEST PRESSURE </b></label>
                                    <div class="col d-flex">
                                        <img src="../img/calculator-spherical-shells-press-concave/hidrostatic-test-pressure.png" width="300px" alt="Formula for HTP">
                                    </div>
                                </div>
                            </th>
                            <td style="text-align: center;">HTP</td>
                            <td style="text-align: center;">
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.hidrostaticTestPressure }}
                                </h6>
                            </td>
                            <td style="text-align: center;">MPa</td>
                        </tr>
                        <tr>
                            <th scope="row" style="text-align: left;">
                                Pneumatic Test Pressure
                                <div class="form-group mt-3 row">
                                    <label class="mt-1"><b>PNEUMATIC TEST PRESSURE </b></label>
                                    <div class="col d-flex">
                                        <img src="../img/calculator-spherical-shells-press-concave/pneumatic-test-pressure.png" width="300px" alt="Formula for PTP">
                                    </div>
                                </div>
                            </th>
                            <td style="text-align: center;">PTP</td>
                            <td style="text-align: center;">
                                <h6 class="text my-auto">
                                    {{ sphericalShellsPressConcaveCalculator.pneumaticTestPressure }}
                                </h6>
                            </td>
                            <td style="text-align: center;">MPa</td>
                        </tr>
                    </tbody>
                </table>

            </div>
            
        </form>
    </div>
</template>

<script>
import DatabaseThickPlateASTM_A20 from "@/models/database/DatabaseThickPlateASTM_A20.js";
import arrayMateriaisASMEII from "../../../../backend/src/database/asmeii/arrayMateriaisASMEII.js";
import InterrogacaoHover from "../../componentesTelas/InterrogacaoHover.vue";
import DesenhoApoio from "../../componentesTelas/DesenhoApoio.vue";

export default {
    name: "SphericalShellsPressConcaveCalculatorComponent",
    props: {
        sphericalShellsPressConcaveCalculatorProps: {
            type: Object,
            required: true,
        },
        designData: {
            type: Object,
            required: true,
        },
        posicao: {
            type: String,
            default: ''
        },
    },
    components: {
        InterrogacaoHover,
        DesenhoApoio
    },
    data() {
        return {
            sphericalShellsPressConcaveCalculator: this.sphericalShellsPressConcaveCalculatorProps,
            nominalThicknessOptions: [],
            materialSpecificationOptions: [], // Armazena todos os materiais

            // BUSCA MATERIAL
            materialSearch: "",
            mostrarListaMaterial: false,
            debounceTimeout: null,

            // EXIBIR DESENHO DE APOIO
            showDrawing: false,
        };
    },
    watch: {
        // Verifica a posição do tampo
        posicao: {
            immediate: true,
            handler(novaPosicao) {
                if (!novaPosicao) return;

                // garante que o campo exista
                this.sphericalShellsPressConcaveCalculator.posicao = novaPosicao;

            }
        },

        // Seta o valor do material no campo de busca
        'sphericalShellsPressConcaveCalculator.materialSpecification': {
            immediate: true,
            deep: true,
            handler(material) {
            if (
                material &&
                typeof material === 'object' &&
                material.materialSpecification
            ) {
                this.materialSearch = material.materialSpecification;
            }
            }
        }
    },

    computed: {
        // Verifica a posição do designData
        designDataPosition() {
            if (this.designData?.position) {
                return this.designData.position;
            }
            return null;
        },

        // Lista de materiais filtrados
        materiaisFiltrados() {
            const termo = this.materialSearch.toLowerCase().trim();
            
            let resultados;
            
            if (!termo) {
                resultados = this.materialSpecificationOptions;
            } else {
                resultados = this.materialSpecificationOptions.filter(mat => {
                    const materialName = mat.materialSpecification?.toLowerCase() || '';
                    return materialName.includes(termo);
                });
            }
            
            // ORDENAÇÃO GARANTIDA - por materialSpecification em ordem crescente
            const resultadosOrdenados = [...resultados].sort((a, b) => {
                const nameA = (a.materialSpecification || '').toString();
                const nameB = (b.materialSpecification || '').toString();
                
                // Extrai números dos nomes para ordenação numérica apropriada
                const numMatchA = nameA.match(/\d+/g);
                const numMatchB = nameB.match(/\d+/g);
                
                // Se ambos têm números, ordena numericamente
                if (numMatchA && numMatchB) {
                    // Compara o primeiro número encontrado
                    const numA = parseInt(numMatchA[0]);
                    const numB = parseInt(numMatchB[0]);
                    
                    if (numA !== numB) {
                        return numA - numB;
                    }
                }
                
                // Fallback para ordenação alfabética com localeCompare
                return nameA.localeCompare(nameB, undefined, { 
                    numeric: true,
                    sensitivity: 'base'
                });
            });
            
            return resultadosOrdenados;
        }

    },

    mounted() {

    },
    created() {
        const database1 = new DatabaseThickPlateASTM_A20();
        this.nominalThicknessOptions = database1.nominalThickness;

        // Carrega e ORDENA os materiais em ordem crescente
        this.carregarMateriaisOrdenados();

    },

    methods: {

        // CONTROLES DO DESENHO DE APOIO
        mostrarDesenho() {
            if(this.showDrawing === false){
                this.showDrawing = true;
            }
            else{
                this.showDrawing = false;
            }            
        },

        // CONTROLE DA IMAGEM FLUTUANTE
        startDrag(e) {
            this.dragging = true
            this.offsetX = e.clientX - this.posX
            this.offsetY = e.clientY - this.posY

            document.addEventListener('mousemove', this.onDrag)
            document.addEventListener('mouseup', this.stopDrag)
        },

        onDrag(e) {
            if (!this.dragging) return
            this.posX = e.clientX - this.offsetX
            this.posY = e.clientY - this.offsetY
        },

        stopDrag() {
            this.dragging = false
            document.removeEventListener('mousemove', this.onDrag)
            document.removeEventListener('mouseup', this.stopDrag)
        },

        abrirListaMaterial() {
            this.mostrarListaMaterial = true;
        },

        fecharListaMaterial() {
            setTimeout(() => {
            this.mostrarListaMaterial = false;
            }, 150);
        },

        // Método para carregar e ordenar materiais
        carregarMateriaisOrdenados() {
            if (Array.isArray(arrayMateriaisASMEII)) {
                // Ordena os materiais pelo materialSpecification em ordem crescente
                this.materialSpecificationOptions = arrayMateriaisASMEII
                    .slice() // Cria uma cópia
                    .sort((a, b) => {
                        const materialA = a.materialSpecification || '';
                        const materialB = b.materialSpecification || '';
                        
                        // Extrai números para ordenação numérica
                        const numMatchA = materialA.match(/\d+/g);
                        const numMatchB = materialB.match(/\d+/g);
                        
                        if (numMatchA && numMatchB) {
                            const numA = parseInt(numMatchA[0]);
                            const numB = parseInt(numMatchB[0]);
                            
                            if (numA !== numB) {
                                return numA - numB;
                            }
                        }
                        
                        // Ordenação alfabética para strings sem números ou números iguais
                        return materialA.localeCompare(materialB, undefined, { 
                            numeric: true,
                            sensitivity: 'base'
                        });
                    });
                
            } else {
                console.error('arrayMateriaisASMEII não é um array válido');
                this.materialSpecificationOptions = [];
            }
        },

        // Método para lidar com input enquanto digita
        handleInput() {
            // Limpa timeout anterior
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }
            
            // Abre a lista imediatamente quando começa a digitar
            if (this.materialSearch.trim() !== '' && !this.mostrarListaMaterial) {
                this.mostrarListaMaterial = true;
            }
            
            // Se apagou tudo, fecha a lista
            if (this.materialSearch.trim() === '') {
                this.mostrarListaMaterial = false;
                return;
            }
            
            // Configura novo timeout para garantir que a lista fique aberta
            this.debounceTimeout = setTimeout(() => {
                if (this.materialSearch.trim() !== '') {
                    this.mostrarListaMaterial = true;
                }
            }, 100);
        },

        selecionarMaterial(material) {
            this.sphericalShellsPressConcaveCalculator.materialSpecification = material;
            this.materialSearch = material.materialSpecification;
            this.mostrarListaMaterial = false;

            this.atualizarCamposMaterial();
            this.calculos();
        },

        buscarCampoAdmissibleStressDatabaseASMEII(materialSpecification, chaveGrausCelsiusBuscada) {


            if (!materialSpecification || !materialSpecification.rangeDesignTemperatureCelsius) {
                console.warn("Material ou rangeDesignTemperatureCelsius não encontrado");
                return null;
            }

            const tabela = materialSpecification.rangeDesignTemperatureCelsius;

            // 🔹 normaliza a chave buscada
            let chaveNormalizada = chaveGrausCelsiusBuscada;

            if (typeof chaveNormalizada === "string" && chaveNormalizada.includes(",")) {
                chaveNormalizada = chaveNormalizada.replace(",", ".");
            }

            const chaveBuscada = parseFloat(chaveNormalizada);


            // 🔹 se existir valor exato
            if (tabela[chaveNormalizada] !== undefined) {
                return parseFloat(tabela[chaveNormalizada]);
            }

            // 🔹 preparar temperaturas numéricas
            const temperaturasStr = Object.keys(tabela);
            const temperaturasNum = temperaturasStr
                .map(t => parseFloat(t.replace(",", ".")))
                .sort((a, b) => a - b);

            if (chaveBuscada < temperaturasNum[0] || chaveBuscada > temperaturasNum[temperaturasNum.length - 1]) {
                this.$emit("temperatura-fora-faixa", {
                    temperatura: chaveBuscada,
                    minimo: temperaturasNum[0],
                    maximo: temperaturasNum[temperaturasNum.length - 1],
                });
                return null;
            }

            const temperaturaExata = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === chaveBuscada
            );

            if (temperaturaExata !== undefined) {
                return parseFloat(tabela[temperaturaExata]);
            }

            // 🔹 encontrar anterior e posterior
            const indicePosterior = temperaturasNum.findIndex(t => t > chaveBuscada);
            const indiceAnterior = indicePosterior > 0 ? indicePosterior - 1 : -1;

            if (indiceAnterior < 0 || indicePosterior === -1) {
                console.warn("Temperatura fora do range do material");
                this.$emit("temperatura-fora-faixa", {
                    temperatura: chaveBuscada,
                    minimo: temperaturasNum[0],
                    maximo: temperaturasNum[temperaturasNum.length - 1],
                });
                return null;
            }

            const tempAnterior = temperaturasNum[indiceAnterior];
            const tempPosterior = temperaturasNum[indicePosterior];

            const chaveAnteriorStr = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === tempAnterior
            );
            const chavePosteriorStr = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === tempPosterior
            );

            const valorAnterior = parseFloat(tabela[chaveAnteriorStr]);
            const valorPosterior = parseFloat(tabela[chavePosteriorStr]);

            // 🔹 interpolação linear (mesma lógica do backend)
            const fator =
                (chaveBuscada - tempAnterior) /
                (tempPosterior - tempAnterior);

            const interpolado =
                valorAnterior + (valorPosterior - valorAnterior) * fator;

            return interpolado.toFixed(2);

            // return Number(interpolado.toFixed(3));
        },

        atualizarCamposMaterial() {
            const materialSelecionado = this.sphericalShellsPressConcaveCalculator.materialSpecification;
            if (materialSelecionado) {
                this.sphericalShellsPressConcaveCalculator.nominalComposition = materialSelecionado.nominalComposition || '';
                this.sphericalShellsPressConcaveCalculator.productForm = materialSelecionado.productForm || '';
                this.sphericalShellsPressConcaveCalculator.alloyDesignation = materialSelecionado.alloyDesignation || '';
                this.sphericalShellsPressConcaveCalculator.classConditionTemper = materialSelecionado.classConditionTemper || '';
                this.sphericalShellsPressConcaveCalculator.pNo = materialSelecionado.pNo || '';
                this.sphericalShellsPressConcaveCalculator.groupNo = materialSelecionado.groupNo || '';
                this.sphericalShellsPressConcaveCalculator.minTensileStrength = materialSelecionado.minTensileStrength || '';
                this.sphericalShellsPressConcaveCalculator.minYieldStrength = materialSelecionado.minYieldStrength || '';
                this.sphericalShellsPressConcaveCalculator.viiiApplicAndMaxTemLimit = materialSelecionado.viiiApplicAndMaxTemLimit || '';
                this.calculos();
            } else {
                console.warn("Material não encontrado no DatabaseASMEII");
            }
        },
        async calculos(){
            if (this.$refs.formCalculo && !this.$refs.formCalculo.reportValidity()) {
                return;
            }

            // -- PARTE 1 - DESIGN DATA -- //

            // RANGE DESIGN TEMPERATURE
            if(this.sphericalShellsPressConcaveCalculator.viiiApplicAndMaxTemLimit === "NP"){
                this.sphericalShellsPressConcaveCalculator.rangeDesignTemperature = this.sphericalShellsPressConcaveCalculator.viiiApplicAndMaxTemLimit;
            }
            else if(this.converterParaFloat(this.sphericalShellsPressConcaveCalculator.viiiApplicAndMaxTemLimit) >= this.designData.rangeDesignTemperature){
                this.sphericalShellsPressConcaveCalculator.rangeDesignTemperature = this.designData.rangeDesignTemperature
            } 
            else if(this.converterParaFloat(this.sphericalShellsPressConcaveCalculator.viiiApplicAndMaxTemLimit) <= this.designData.rangeDesignTemperature){
                this.sphericalShellsPressConcaveCalculator.rangeDesignTemperature = "TEMPERATURE OVER MATERIAL LIMIT";
            }

            // FLUID DENSITY
            this.sphericalShellsPressConcaveCalculator.fluidDensity = this.designData.density;

            // DESIGN PRESSURE ON THE TOP OF THE VESSEL
            this.sphericalShellsPressConcaveCalculator.designPressureTop = this.designData.designInternalPressure;

            // DESIGN PRESSURE
            this.sphericalShellsPressConcaveCalculator.designPressure = ((this.sphericalShellsPressConcaveCalculator.liquidColumn * this.sphericalShellsPressConcaveCalculator.fluidDensity * 9.81) / 1000000) + this.sphericalShellsPressConcaveCalculator.designPressureTop;

            // ADMISSIBLE STRESS @ DESIGN TEMPERATURE
            if (this.sphericalShellsPressConcaveCalculator.rangeDesignTemperature === "TEMPERATURE OVER MATERIAL LIMIT") {
                this.sphericalShellsPressConcaveCalculator.admissibleStressDesignTemp = "...";
            } else {
                // Buscar passando id do material
                const chaveGrausCelsiusBuscada = this.sphericalShellsPressConcaveCalculator.designTemperature;

                try {
                    const resultado = await this.buscarCampoAdmissibleStressDatabaseASMEII(
                        this.sphericalShellsPressConcaveCalculator.materialSpecification,
                        chaveGrausCelsiusBuscada
                    );

                    this.sphericalShellsPressConcaveCalculator.admissibleStressDesignTemp = resultado;
                    
                } catch (error) {
                    console.error("Erro ao buscar admissibleStressDesignTemp:", error);
                }
            }

            // ADMISSIBLE STRESS @ ROOM TEMPERATURE 
            try {
                const resultado = await this.buscarCampoAdmissibleStressDatabaseASMEII(
                    this.sphericalShellsPressConcaveCalculator.materialSpecification,
                    "37,78"
                );

                this.sphericalShellsPressConcaveCalculator.admissibleStressRoomTemp = resultado;

            } catch (error) {
                console.error("Erro ao buscar admissibleStressRoomTemp:", error);
            }

            // INSIDE RADIUS
            this.sphericalShellsPressConcaveCalculator.insideRadius = this.sphericalShellsPressConcaveCalculator.insideDiameter / 2;

            // CORROSION ALLOWANCE
            this.sphericalShellsPressConcaveCalculator.corrosionAllowance = this.designData.corrosionAllowance;

            // INSIDE RADIUS CORRODED
            this.sphericalShellsPressConcaveCalculator.insideRadiusCorroded = (this.sphericalShellsPressConcaveCalculator.insideDiameter / 2) + this.sphericalShellsPressConcaveCalculator.corrosionAllowance;

            // NOMINAL THICKNESS minus Corrosion Allowance
            this.sphericalShellsPressConcaveCalculator.nominalThicknessMinusCorrosionAloowance = this.sphericalShellsPressConcaveCalculator.nominalThickness - this.sphericalShellsPressConcaveCalculator.corrosionAllowance;

            // VALID OU INVALID NOMINAL THICKNESS
            if(this.sphericalShellsPressConcaveCalculator.nominalThickness < this.sphericalShellsPressConcaveCalculator.designThickness){
                this.sphericalShellsPressConcaveCalculator.validNominalThickness = false;
                }
            else {
                this.sphericalShellsPressConcaveCalculator.validNominalThickness = true;
            }

            // -- PARTE 2 - DESIGN VALIDATION -- //

            // DESIGN THICKNESS
            if(this.sphericalShellsPressConcaveCalculator.weldedJointEfficiency === "NA"){
                this.sphericalShellsPressConcaveCalculator.weldedJointEfficiency = 1.0;
            }
            if(this.sphericalShellsPressConcaveCalculator.designPressure < 0.665 * this.sphericalShellsPressConcaveCalculator.admissibleStressDesignTemp * this.sphericalShellsPressConcaveCalculator.weldedJointEfficiency) {
                let resultado = ((this.sphericalShellsPressConcaveCalculator.designPressure * this.sphericalShellsPressConcaveCalculator.insideRadiusCorroded) / ((2 * this.sphericalShellsPressConcaveCalculator.admissibleStressDesignTemp * this.sphericalShellsPressConcaveCalculator.weldedJointEfficiency) - (0.2 * this.sphericalShellsPressConcaveCalculator.designPressure))) + this.sphericalShellsPressConcaveCalculator.corrosionAllowance;
                this.sphericalShellsPressConcaveCalculator.designThickness = resultado.toFixed(3);
            }
            else{
                this.sphericalShellsPressConcaveCalculator.designThickness = "Division 1 cannot be applied according to the UG - 27 (1)";
            }

            // WORKING MAXIMUM ALLOWABLE PRESSURE CORRODED AND HOT
            if(this.sphericalShellsPressConcaveCalculator.validNominalThickness === false){
                this.sphericalShellsPressConcaveCalculator.workingMaximumAllowablePressure = "INVALID NOMINAL THICKNESS";
            }
            else if(this.sphericalShellsPressConcaveCalculator.nominalThickness === 0){
                this.sphericalShellsPressConcaveCalculator.workingMaximumAllowablePressure = 0;
            }
            else if(this.sphericalShellsPressConcaveCalculator.nominalThicknessMinusCorrosionAloowance < (0.365 * this.sphericalShellsPressConcaveCalculator.insideRadiusCorroded)){
                this.sphericalShellsPressConcaveCalculator.workingMaximumAllowablePressure = ((2 * this.sphericalShellsPressConcaveCalculator.admissibleStressDesignTemp * this.sphericalShellsPressConcaveCalculator.weldedJointEfficiency * this.sphericalShellsPressConcaveCalculator.nominalThicknessMinusCorrosionAloowance) / (this.sphericalShellsPressConcaveCalculator.insideRadiusCorroded + 0.2 * this.sphericalShellsPressConcaveCalculator.nominalThicknessMinusCorrosionAloowance)).toFixed(3);
            }
            else{
                this.sphericalShellsPressConcaveCalculator.workingMaximumAllowablePressure = "Division 1 cannot be applied according to the UG - 27 (1)";
            }

            // HIDROSTATIC TEST PRESSURE
            if(this.sphericalShellsPressConcaveCalculator.validNominalThickness === false){
                this.sphericalShellsPressConcaveCalculator.hidrostaticTestPressure = "INVALID NOMINAL THICKNESS";
            }
            else{
                this.sphericalShellsPressConcaveCalculator.hidrostaticTestPressure = (1.3 * this.sphericalShellsPressConcaveCalculator.workingMaximumAllowablePressure * (this.sphericalShellsPressConcaveCalculator.admissibleStressRoomTemp / this.sphericalShellsPressConcaveCalculator.admissibleStressDesignTemp)).toFixed(3);
            }

            // PNEUMATIC TEST PRESSURE
            if(this.sphericalShellsPressConcaveCalculator.validNominalThickness === false){
                this.sphericalShellsPressConcaveCalculator.pneumaticTestPressure = "INVALID NOMINAL THICKNESS";
            }
            else{
                this.sphericalShellsPressConcaveCalculator.pneumaticTestPressure = (1.1 * this.sphericalShellsPressConcaveCalculator.workingMaximumAllowablePressure * (this.sphericalShellsPressConcaveCalculator.admissibleStressRoomTemp / this.sphericalShellsPressConcaveCalculator.admissibleStressDesignTemp)).toFixed(3);
            }
        },
        converterParaFloat(valor) {
            if (valor === "" || valor === null || valor === undefined) {
                return 0;
            }

            const valorString = valor.toString().trim();
            const valorSemEspacos = valorString.replace(/\s+/g, "");
            let valorNormalizado = valorSemEspacos;

            if (valorSemEspacos.includes(",") && valorSemEspacos.includes(".")) {
                const ultimoPonto = valorSemEspacos.lastIndexOf(".");
                const ultimaVirgula = valorSemEspacos.lastIndexOf(",");
                const separadorDecimal = ultimaVirgula > ultimoPonto ? "," : ".";
                const separadorMilhar = separadorDecimal === "," ? "." : ",";

                valorNormalizado = valorSemEspacos
                    .replace(new RegExp(`\\${separadorMilhar}`, "g"), "")
                    .replace(separadorDecimal, ".");
            } else if (valorSemEspacos.includes(",")) {
                valorNormalizado = valorSemEspacos.replace(/,/g, ".");
            }

            const valorConvertido = parseFloat(valorNormalizado);
            return isNaN(valorConvertido) ? 0 : valorConvertido;
        },
    },
};
</script>

<style>
.material-options {
    overflow-x: hidden;
    max-height: 280px;
    overflow-y: auto;
    top: 100%;
    left: 0;
    z-index: 9999;
    border: 1px solid #d7e0ed;
    border-radius: 8px;
    box-shadow: 0 10px 24px rgba(23, 32, 51, 0.14);
}

.material-table {
    overflow: visible !important;
}

.material-option {
    cursor: pointer;
    color: #334e73;
    padding: 11px 14px;
    white-space: normal;
}

.material-option:hover,
.material-option:focus {
    background-color: #edf4ff;
    color: #0056ff;
}
</style>